import 'angular';
import {RootScope} from '../types/angular-types';
import Features from '../feature-manager/Features';

migrationIframeFactory.$inject = ['$timeout', 'RegionService', 'EndpointConfig'];

angular.module('GorillaBoy.FileBrowser')
.directive('migrationIframe', migrationIframeFactory);

function migrationIframeFactory($timeout: ng.ITimeoutService, RegionService: any, EndpointConfig: any) {
    return {
        scope: true,
        link: function migrationIframeLinkFn($scope: RootScope, $element: ng.IRootElementService, $attrs) {
            let embedUrl = "https://datamigration.corp.amazon.com/#/embedded";
            
            const region = RegionService.getRegion(),
            stage = region ? EndpointConfig.stage(region) : null;

            if (stage === 'ALPHA' || stage === 'DEV' || stage === 'GAMMA') {
                embedUrl = 'https://ferrari.corp.amazon.com/#/';
            }
                        
            if ($scope.isFeatureEnabled(Features.UI.SHOW_HDRIVE_MIGRATION)) {
                $element.append(`<iframe height="100%" width="100%" 
                   src="${embedUrl}"
                   style="border: 0px;"></iframe>`);
            }
        }
    };
}
